export const category = [
    {
        name: 'cnn-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'cnbc-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'republika-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'tempo-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'antara-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'kumparan-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'okezone-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'bbc-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'tribun-news',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'jawa-pos',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'vice',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'suara',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
    {
        name: 'voa',
        icon: 'https://img.icons8.com/color/48/000000/cnn.png'
    },
]